import React from 'react';
import {TimePicker , DatePicker, Modal, Form, Icon, Input, Button, message, Radio, Row,Checkbox, Select,Switch,InputNumber } from 'antd';
import {connect} from "react-redux";
import {updateCheckinpoint} from "../../services/checkinpoint";
import lodash from "lodash"
import moment from 'moment';
import {isValidity} from "../../services/global";
import PurchaseServiceTips from "../PurchaseServiceTips";



class EvtViewCheckinpointPeriodicTime extends React.Component {


 

    constructor(props) {
        super(props);
        this.pstView =null;
        this.state = {
            isMember:'SENIORMEMBER',
            permissionPass: false,
            beginTime:null,
            formLoading: false,
            enableCheckinTimingVisible:props.data.enableCheckinTiming,
            enableTailSignatureVisible:props.data.enableTailSignature,


        }
    }

    componentDidMount() {
        isValidity('CHECKINTIMING', (vaild) => this.setState({ permissionPass: vaild}));
    }

    componentWillReceiveProps(nextProps) {

    }
    

    changeFormLoading = (loading) => {
        this.setState({
            formLoading: loading
        })
    }

    onSubmit = () => {
        if (!this.state.permissionPass) {
            this.pstView.show();
        } else {
            this.props.form.validateFieldsAndScroll((error, values) => {
                if (!error) {
                    if (values.beginTime && values.endTime) {
                        values.beginTime = values.beginTime.format("YYYY-MM-DD HH:mm:ss");
                        values.endTime = values.endTime.format("YYYY-MM-DD HH:mm:ss");
                    } else {
                        values.beginTime = null;
                        values.endTime = null;
                    }

                    if (values.checkinTimingSlots) {
                        values.checkinTimingSlots.forEach(element => {
                            element.beginTime = element.beginTime.format("HH:mm:ss");
                            element.endTime = element.endTime.format("HH:mm:ss");
                        })
                    }
                    console.log('ok', values);
                    this.changeFormLoading(true);
                    updateCheckinpoint(Object.assign(this.props.data, values)).then(res => {
                        if (res.code == 200) {
                            message.info("保存成功!");
                            this.props.editableChange(this.props.editableStatePropName, false, true)
                        } else {
                            message.error(res.msg,6);
                        }
                    }).catch(err => {
                        message.warn("访问异常");
                    }).finally(() => {
                        this.changeFormLoading(false)
                    })


                } else {
                    message.error('请选择签到的具体时间段！')

                }
            });
        }
    }
    addField = (fieldName, value = {}) => {
        const {form} = this.props;
        var fieldsValue = form.getFieldsValue();
        var _fieldVal = lodash.get(fieldsValue, `_${fieldName}`);
        _fieldVal.push(value);

        lodash.set(fieldsValue, `_${fieldName}`, _fieldVal);


        form.setFieldsValue(fieldsValue);

    }


    removeField = (fieldName, index) => {
        const {form} = this.props;
        var fieldsValue = form.getFieldsValue();
        let fieldVal = lodash.get(fieldsValue, fieldName);
        let _fieldVal = lodash.get(fieldsValue, `_${fieldName}`);
        fieldVal.splice(index, 1);
        _fieldVal.splice(index, 1);

        lodash.set(fieldsValue, `_${fieldName}`, _fieldVal);
        lodash.set(fieldsValue, fieldName, fieldVal);

        form.setFieldsValue(fieldsValue);

    }



    render() {
        const {getFieldDecorator, getFieldValue,getFieldsValue,setFieldsValue} = this.props.form;
        const {data} = this.props;
        let {enableCheckinTimingVisible,enableTailSignatureVisible} = this.state;
        getFieldDecorator('_checkinTimingSlots', {initialValue: data.checkinTimingSlots ? data.checkinTimingSlots : []});
        const checkinTimingSlots = getFieldValue('_checkinTimingSlots') ? getFieldValue('_checkinTimingSlots') : [];
        console.log(getFieldsValue())

        return (
            <div>
                <Modal
                    width={550}
                    title={`签到点-${data.name}(高级签到配置，如，周期性签到)`}
                    visible={this.props.visible}
                    onCancel={() => this.props.hide()}
                    footer={[
                        <Button key="back" onClick={()=>this.props.hide()}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary" loading={this.state.formLoading} onClick={this.onSubmit}>
                            保存
                        </Button>,
                    ]}
                >
                    <div>
                        <Form.Item
                            extra='0表示不限'
                            label="每人可重签次数"
                        >
                            {getFieldDecorator('maxCheckinCount', {
                                initialValue: data.maxCheckinCount,
                                rules: [{required: true, message: '必填项'},],
                            })(
                                <InputNumber min={-1}
                                             style={{width:120}}
                                />
                            )}
                        </Form.Item>
                        <Form.Item
                            label="同一人重复签到间隔"
                        >
                            {getFieldDecorator('nextCheckinTime', {
                                initialValue: data.nextCheckinTime,
                                rules: [{required: true, message: '必填项'},],
                            })(
                                <InputNumber min={getFieldsValue().nextCheckinTimeUnit && getFieldsValue().nextCheckinTimeUnit == 'SECOND' ? 10 : 1}
                                             style={{width:120}}
                                />
                            )}
                        </Form.Item>
                        <Form.Item
                            label="时间间隔单位"
                        >
                            {getFieldDecorator('nextCheckinTimeUnit', {
                                initialValue: data.nextCheckinTimeUnit,
                                rules: [
                                    {required: true, message: '请选择时间间隔单位'},
                                ],
                            })(
                                <Select style={{width:120}} onChange={e=>{
                                    let fieldsValue=getFieldsValue();
                                    if(e == 'SECOND' && fieldsValue.nextCheckinTime < 10){
                                        fieldsValue.nextCheckinTime =10;
                                        setFieldsValue(fieldsValue);
                                    }
                                }}>
                                    {
                                        Object.values(this.props.cmEnums.data.NextCheckinTimeUnit).map((item, index) => {
                                            return <Select.Option value={item.enumName.toString()} key={`checkin-time-${index}`}>{item.enumDesc}</Select.Option>
                                        })
                                    }
                                </Select>
                            )}
                        </Form.Item>
                        <div style={{lineHeight:'30px'}}>可签到时间范围：</div>
                        <div style={{marginBottom:12}}>
                            {getFieldDecorator('beginTime', {
                                initialValue:data.beginTime ? moment(data.beginTime, 'YYYY-MM-DD HH:mm:ss') : null,
                                rules: [
                                    {required: false,}
                                ],
                            })(
                                <DatePicker
                                    showTime={{
                                        hideDisabledOptions: true,
                                    }}
                                    placeholder="开始时间"
                                    format="YYYY-MM-DD HH:mm:ss"
                                    style={{width: "200px"}}
                                    onChange={startValue => {
                                        this.setState({beginTime:startValue})
                                    }
                                    }
                                />
                            )}
                            <span style={{margin:'0 6px'}}> ~ </span>
                            {getFieldDecorator('endTime', {
                                initialValue:data.endTime ? moment(data.endTime, 'YYYY-MM-DD HH:mm:ss') : null,
                                rules: [
                                    {required: false,}
                                ],
                            })(
                                <DatePicker
                                    disabledDate={endValue=>{
                                        const startValue = this.state.beginTime;
                                        if (!endValue || !startValue) {
                                            return false;
                                        }
                                        return endValue.valueOf() <= startValue.valueOf();
                                    }}
                                    showTime={{
                                        hideDisabledOptions: true,
                                    }}
                                    placeholder="结束时间"
                                    format="YYYY-MM-DD HH:mm:ss"
                                    style={{width: "200px"}}
                                    onChange={endValue => {
                                    }

                                    }
                                />
                            )}
                        </div>
                        <Form.Item
                            label="添加可签时间段（开启后，在下方指定每天可签的时间段）"
                        >
                            {getFieldDecorator(`enableCheckinTiming`, {
                                initialValue: data.enableCheckinTiming,
                                valuePropName: 'checked',
                                rules: [{required: false}],
                            })(
                                <Switch
                                    onChange={(checked)=>{
                                        this.setState({enableCheckinTimingVisible:checked});
                                        if(!checked){
                                            this.setState({enableTailSignatureVisible:false});
                                            var fieldsValue = this.props.form.getFieldsValue();
                                            lodash.set(fieldsValue, 'enableTailSignature', false);
                                            this.props.form.setFieldsValue(
                                                fieldsValue
                                            )
                                        }
                                    }}
                                    checkedChildren={"开启"}
                                    unCheckedChildren={"关闭"}/>
                            )}
                        </Form.Item>
                        <Form.Item
                            style={{display:enableCheckinTimingVisible ? 'block' : 'none'}}
                            label="签到和签退"
                        >
                            {getFieldDecorator(`enableTailSignature`, {
                                initialValue: data.enableTailSignature,
                                valuePropName: 'checked',
                                rules: [{required: false}],
                            })(
                                <Switch
                                    onChange={(checked)=>{
                                        this.setState({enableTailSignatureVisible:checked});
                                    }}
                                    checkedChildren={"开启"}
                                    unCheckedChildren={"关闭"}/>
                            )}
                        </Form.Item>
                        <div style={{lineHeight:'30px'}}>每天具体时间：</div>
                        <div style={{marginBottom:12}}>
                            {checkinTimingSlots.map((obj,index)=>{
                                return  <span key={index} style={{display:'block',marginBottom:12}}>
                                    {getFieldDecorator(`checkinTimingSlots[${index}].beginTime`, {
                                        initialValue:obj.beginTime ? moment(obj.beginTime, 'HH:mm') : null,
                                        rules: [
                                            {required: true,}
                                        ],
                                    })(
                                        <TimePicker placeholder="开始" format={'HH:mm'} />
                                    )}
                                    <span style={{margin:'0 6px'}}> ~ </span>
                                    {getFieldDecorator(`checkinTimingSlots[${index}].endTime`, {
                                        initialValue:obj.endTime ? moment(obj.endTime, 'HH:mm') : null,
                                        rules: [
                                            {required: true,}
                                        ],
                                    })(
                                        <TimePicker style={{marginRight:14}} placeholder="结束" format={'HH:mm'} />
                                    )}
                                    {getFieldDecorator(`checkinTimingSlots[${index}].tailSignature`, {
                                        initialValue: obj.tailSignature ? obj.tailSignature : false,
                                        valuePropName: 'checked',
                                        rules: [{required: false}],
                                    })(
                                        <Checkbox style={{fontSize:12,display:enableTailSignatureVisible ? 'inline-block' : 'none'}}>设定为签退</Checkbox>
                                    )}
                                    <a  onClick={() => this.removeField("checkinTimingSlots", index)}
                                        style={{fontSize:14,position:'relative',top:1}}><Icon type='delete' /></a>
                            </span>
                            })}
                            <div>
                                <a onClick={() => this.addField("checkinTimingSlots")}><Icon type='plus' />添加时间</a>
                            </div>
                        </div>
                    </div>

                </Modal>
                <PurchaseServiceTips
                    ref={(pst) => {
                        this.pstView = pst
                    }}
                    member={this.state.isMember}
                />
            </div>
        );
    }
}


EvtViewCheckinpointPeriodicTime.contextTypes = {};

EvtViewCheckinpointPeriodicTime.defaultProps = {};

EvtViewCheckinpointPeriodicTime.propTypes = {}


const mapStateToPorps = state => {
    const cmEnums = state.cmEnums;
    return {cmEnums};
};
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToPorps, mapDispatchToProps)(Form.create()(EvtViewCheckinpointPeriodicTime));




// WEBPACK FOOTER //
// ./src/containers/evt/EvtViewCheckinpointPeriodicTime.jsx